<div class="requests">
  <div class="title">
    <h1>New Template</h1>
    <button type="button" class="btn" (click)="bsModalRef.hide()" data-dismiss="modal" aria-label="Close">
      <i class="material-icons">close</i>
    </button>
  </div>
  <div class="content">
    <form [formGroup]="integrationForm" (ngSubmit)="submit()">
      <div class="form-group">
        <label for="user">Content</label>
        <input type="text" class="form-control" formControlName="content"
          [ngClass]="{ 'is-invalid': submitted && formControls.content.errors }">
      </div>

      <div class="form-group">
        <label for="user">Name</label>
        <input type="text" class="form-control" formControlName="name"
          [ngClass]="{ 'is-invalid': submitted && formControls.name.errors }">
      </div>

      <div class="form-check">
        <input type="checkbox" class="form-check-input" formControlName="isWelcome">
        <label class="form-check-label" for="exampleCheck1">Welcome Template ?</label>
      </div>

      <button type="submit" class="btn button w-100">Submit</button>
    </form>
  </div>
</div>
